import { render, staticRenderFns } from "./RegistryRequestGrid.vue?vue&type=template&id=18ca943d&"
import script from "./RegistryRequestGrid.vue?vue&type=script&lang=js&"
export * from "./RegistryRequestGrid.vue?vue&type=script&lang=js&"
import style0 from "./RegistryRequestGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports